/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================
​
* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
​
Coded by www.creative-tim.com
​
 =========================================================
​
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
// @mui material components
import Card from "@mui/material/Card";
// Material Dashboard 2 PRO React components

import MDTypography from "../../components/MDTypography";
import MDBox from "../../components/MDBox";
import { useEffect } from "react";

function ApplicationsCard({ color, title, content }) {
  useEffect(() => {}, []);

  return (
    <MDBox sx={{ pb: { xs: 3, md: 0 } }}>
      <Card pt={0}>
        <MDBox
          // display="flex"
          minHeight="8rem"
          flexDirection="column"
          justifyContent="space-between"
          pt={0.5}
          px={2}
        >
          {/* Title of Application Card */}
          <MDBox
            variant="gradient"
            bgColor={color}
            color={color === "light" ? "dark" : "white"}
            coloredShadow={color}
            borderRadius="xl"
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="11rem"
            height="2rem"
            mt={-3}
          >
            <MDTypography variant="button" fontWeight="bold" color="white">
              {title}
            </MDTypography>
          </MDBox>
          {content != undefined && (
            <MDBox
              alignItems="center"
              justifyContent="center"
              ml={0}
              mt={0}
              pb={2}
            >
              {content}
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
// Setting default values for the props of ComplexStatisticsCard
ApplicationsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
  title: "das",
  loading: true,
  subtitle: "xx",
  itemsPerPage: 3,
};

// Typechecking props for the ComplexApplicationsCard
ApplicationsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),

  icon: PropTypes.node.isRequired,
};

export default ApplicationsCard;
